module.exports = {
      id: "Infobulle-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Infobulle-usage",
      toString: function () {
        return this.url;
      }
    }